import { SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

import TourInfoBox from '@/components/Landing/TourInfoBox'
import { IconStarRating } from '@/components/Ui/Icons/IconStartRating'
import { Excursion } from '@/core/interface/Excursion'

type Props = {
  viewRoute: Excursion
  nextStep: boolean
  setViewRoute: (value: SetStateAction<Excursion | null>) => void
  startExcursion: (id: string, firstPointId: string) => void
  onClose: () => void
}

export function StartExcursionSection(props: Props) {
  const { viewRoute, nextStep, setViewRoute, startExcursion, onClose } = props
  const { t } = useTranslation('routes')

  let initialCoordinates = {}
  if (viewRoute && viewRoute.landmarks.length) {
    initialCoordinates = viewRoute.landmarks[0].coordinate
  }

  const startPointGoogleMapsLink = `https://maps.google.com/?q=${initialCoordinates['latitude']},${initialCoordinates['longitude']}`

  function start() {
    setViewRoute(null)
    startExcursion(viewRoute.id, viewRoute?.landmarks[0].id)
    const trialTours = localStorage.getItem('trialTours')

    if (!trialTours) {
      localStorage.setItem('trialTours', '1')
      return startExcursion(viewRoute.id, viewRoute?.landmarks[0].id)
    }

    if (trialTours === 'trial') {
      return startExcursion(viewRoute.id, viewRoute?.landmarks[0].id)
    }

    if (parseInt(trialTours) !== 3) {
      const tourValue = trialTours ? (parseInt(trialTours) + 1).toString() : '1'
      localStorage.setItem('trialTours', tourValue)
      return startExcursion(viewRoute.id, viewRoute?.landmarks[0].id)
    }

    onClose()
    localStorage.setItem('trialTours', 'trial')
  }

  if (!nextStep) {
    return (
      <>
        <p className="routes__title second-screen">
          {!viewRoute ? t('firstScreen.title') : viewRoute.title}
        </p>
        <p className={'view__title second-screen'}>
          {t('secondScreen.select.p')}
          <span>{t('secondScreen.select.span')}</span>
        </p>
      </>
    )
  }

  return (
    <>
      <p className="routes__title second-screen">
        {!viewRoute ? t('firstScreen.title') : viewRoute.title}
      </p>
      <div className="routes__raiting">
        <IconStarRating rating={4}></IconStarRating>
      </div>
      <div>
        <TourInfoBox time="4" distance="4" price={viewRoute.price} discount={viewRoute?.discount} old_price={viewRoute?.old_price}></TourInfoBox>
      </div>
      <div className="view__title__wrapper">
        <p className="view__title second-screen">
          {t('secondScreen.unselect.p1')}
          <a href={startPointGoogleMapsLink} target="blank">
            <span>{t('secondScreen.unselect.span')}</span>
          </a>
          {t('secondScreen.unselect.p2')}
        </p>
        <button className="view__route" onClick={start}>
          {t('secondScreen.start')} &gt;
        </button>
      </div>
    </>
  )
}
